import React, { useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";
import Header from "../../Components/Header/Header";
import { PASSWORD_HELP, passwordRules } from "Services/passwordRules";

const UpdateForgotPassword = () => {
    const { token } = useParams();
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm();

    const password = watch("password");

    const onSubmit = async (data) => {
        try {
            await axios.post(
                `${process.env.REACT_APP_BASE_URL_API}/update-forgot-password`,
                {
                    token,
                    password: data.password
                }
            );

            setIsError(false);
            setMessage("Votre mot de passe a été mis à jour.");
            window.location.href = "/";
        } catch (error) {
            setIsError(true);
            // Le back renvoie un message explicite (mot de passe trop faible, lien expiré…) :
            // l'afficher plutôt que de conclure systématiquement à un lien invalide.
            setMessage(
                error?.response?.data?.message || "Lien invalide ou expiré."
            );
        }
    };

    return (
        <div>
            <Header />
            <div className="contactPage text-center">
                <h2>Réinitialiser votre mot de passe</h2>

                <form onSubmit={handleSubmit(onSubmit)}>

                    {/* Password */}
                    <div className="field">
                        <label><b>Nouveau mot de passe</b></label>
                        <br /><br />

                        <Controller
                            name="password"
                            control={control}
                            rules={passwordRules()}
                            className="forgot_password_password"
                            render={({ field, fieldState }) => (
                                <Password
                                    id={field.name}
                                    {...field}
                                    toggleMask
                                    feedback
                                    placeholder="********"
                                    className={classNames({
                                        "p-invalid": fieldState.invalid
                                    })}
                                />
                            )}
                        />

                        <div>
                            {errors.password ? (
                                <small className="p-error">
                                    {errors.password.message}
                                </small>
                            ) : (
                                <small>{PASSWORD_HELP}</small>
                            )}
                        </div>
                    </div>

                    <br />

                    {/* Confirm Password */}
                    <div className="field">
                        <label><b>Confirmer le mot de passe</b></label>
                        <br /><br />

                        <Controller
                            name="confirmPassword"
                            control={control}
                            rules={{
                                required: "Confirmation requise",
                                validate: (value) =>
                                    value === password ||
                                    "Les mots de passe ne correspondent pas",
                            }}
                            className="forgot_password_password"
                            render={({ field, fieldState }) => (
                                <Password
                                    id={field.name}
                                    {...field}
                                    toggleMask
                                    feedback={false}
                                    placeholder="********"
                                    className={classNames({
                                        "p-invalid": fieldState.invalid
                                    })}
                                />
                            )}
                        />

                        {errors.confirmPassword && (
                            <div>
                                <small className="p-error">
                                    {errors.confirmPassword.message}
                                </small>
                            </div>
                        )}
                    </div>

                    <br />

                    <button type="submit" className="btn btn-danger">
                        Mettre à jour
                    </button>

                    {message && <p>{message}</p>}

                    {isError && (
                        <p>
                            <Link to="/" className="home-link">
                                Retour à la page d’accueil
                            </Link>
                        </p>
                    )}

                </form>
            </div>
        </div>
    );
};

export default UpdateForgotPassword;